import React from 'react';
import { Shield } from 'lucide-react';
import ActiveSessions from '../../../components/admin/ActiveSessions';

const AdminSessionsTab = () => (
  <div className="max-w-3xl space-y-4" data-testid="admin-sessions-tab">
    <div>
      <h2 className="font-heading text-lg font-bold text-[#0A0A0A] flex items-center gap-2">
        <Shield className="w-5 h-5 text-[#BA1826]" />
        Active Sessions
      </h2>
      <p className="text-sm text-[#4B5563] mt-1">
        Super-admin override panel. View every admin currently signed in across devices, and revoke any session immediately.
        Revoked users are forced to sign in again on their next request.
      </p>
    </div>
    <ActiveSessions scope="all" />
  </div>
);

export default AdminSessionsTab;
